import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'store/store';
import * as i18nActions from "store/ducks/i18n/actions";
import cn from 'classnames'
import './LangList.sass'

const langs = [
	{
		lang: "ru",
	},
	{
		lang: "oz",
	},
	{
		lang: "uz",
	},
	{
		lang: "kaa",
	},
	{
		lang: "en",
	},
];

const LangList: React.FC = () => {
	const { lang } = useSelector((state: AppState) => state.i18n);
	const dispatch = useDispatch()

	const setLangHandler = (lang: string) => {
		dispatch(i18nActions.setLang(lang));
	};

  return (
    <div className="lang-list">
      {langs.filter((i) => i.lang !== 'kaa').map((ii) => (
        <div 
					onClick={() => setLangHandler(ii.lang)}
          key={ii.lang}
          className={cn ('lang-list__item', {
            'lang-list__item--active': ii.lang === lang
          })}
          >{ii.lang}</div>
      ))}
    </div>
  )
}

export default LangList